<template>
    <div>
        <div class="intro">
          <span>
            <div style="width:1em;height:1em;background:#2d8cf0"></div>
            免费解锁
          </span>
          <span>
            <div style="width:1em;height:1em;background:#19be6b"></div>
            广告解锁
          </span>
          <span>
            <div style="width:1em;height:1em;background:#ff9900"></div>
            金币解锁
          </span>
          <span>
            <div style="width:1em;height:1em;background:#ed4014"></div>
            vip解锁
          </span>
        </div>
        <div class="contain">
          <div v-for="(item,index) in data" :key="index">
              <div class="episode-body">
                <div :style="{background:item.free?'#2d8cf0':'transparent'}"></div>
                <div :style="{background:item.ads?'#19be6b':'transparent'}"></div>
                <div :style="{background:item.coins?'#ff9900':'transparent'}"></div>
                <div :style="{background:item.vip?'#ed4014':'transparent'}"></div>
              </div>
              <div style="text-align: center;">第{{ index+1 }}集</div>
          </div>
        </div>

    </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {

    }
  },
  mounted() {
    console.log(this.data)
  }
}
</script>

<style lang="less" scoped>

.intro{
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
  &>span{
    display: inline-flex;
    align-items: center;
    margin-right: 20px;
    &>div{
      margin-right: 10px;
    }
  }
}

.contain{
  width: 100%;
  display:flex;
  flex-wrap: wrap;
  margin: -8px;
  &>div{
    margin: 8px;
  }
}
.episode-body{
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  display:flex;
  // text-align: center;
  justify-content: space-between;
  width:30px;
  flex-wrap: wrap;
  height: 30px;
  &>div{
    width:50%;
    flex: 0 0 50%;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
  }
}
</style>
